import { render, staticRenderFns } from "./attached_file_pdf.vue?vue&type=template&id=3f5ea59a"
import script from "./attached_file_pdf.vue?vue&type=script&lang=js"
export * from "./attached_file_pdf.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports